import React, { useEffect, useState } from 'react';
import PayrollLayout from '../../layouts/PayrollLayout';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default function Reports() {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const dummy = [
        { id: 1, title: 'April 2024 Payroll Summary', date: '2024-04-30' },
        { id: 2, title: 'May 2024 Payslip Report', date: '2024-05-31' },
        { id: 3, title: 'April 2024 Tax Deduction Report', date: '2024-04-28' },
      ];
      setData(dummy);
      setFiltered(dummy);
      setLoading(false);
    }, 1000);
  }, []);

  const filterReports = (term, start, end) => {
    const filteredData = data.filter((r) => {
      const matchesSearch = r.title.toLowerCase().includes(term);
      const matchesDate =
        (!start || new Date(r.date) >= new Date(start)) &&
        (!end || new Date(r.date) <= new Date(end));
      return matchesSearch && matchesDate;
    });
    setFiltered(filteredData);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    filterReports(value, startDate, endDate);
  };

  const handleDateChange = (field, value) => {
    if (field === 'start') setStartDate(value);
    else setEndDate(value);
    filterReports(search, field === 'start' ? value : startDate, field === 'end' ? value : endDate);
  };

  const handleExportCSV = () => {
    const headers = ['Title', 'Date'];
    const rows = filtered.map((r) => [r.title, r.date]);
    const csvContent = [headers, ...rows].map((row) => row.join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'payroll_reports.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [['Title', 'Date']],
      body: filtered.map((r) => [r.title, r.date]),
    });
    doc.save('payroll_reports.pdf');
  };

  const handleDownloadAll = () => {
    alert('Download ZIP of all reports – coming soon!');
  };

  const handleSendToFinance = () => {
    alert('Reports sent to finance@example.com (mock)');
  };

  return (
    <PayrollLayout title="Reports">
      <div className="bg-white dark:bg-gray-900 p-4 rounded-2xl font-poppins space-y-4">
        <div className="flex flex-col lg:flex-row justify-between gap-3">
          <div className="flex flex-wrap gap-2">
            <input
              type="text"
              placeholder="Search reports..."
              value={search}
              onChange={handleSearch}
              className="border dark:bg-black dark:text-white dark:border-gray-700 dark:focus:outline-none px-3 py-2 rounded text-sm w-full sm:w-auto"
            />
            <input
              type="date"
              value={startDate}
              onChange={(e) => handleDateChange('start', e.target.value)}
              className="border dark:bg-black dark:text-white dark:border-gray-700 dark:focus:outline-none px-3 py-2 rounded text-sm"
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => handleDateChange('end', e.target.value)}
              className="border dark:bg-black dark:text-white dark:border-gray-700 dark:focus:outline-none px-3 py-2 rounded text-sm"
            />
          </div>
          <div className="flex flex-wrap gap-2">
            <button onClick={handleExportCSV} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm">Export CSV</button>
            <button onClick={handleExportPDF} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-sm">Export PDF</button>
            <button onClick={handleDownloadAll} className="bg-gray-700 hover:bg-gray-800 text-white px-4 py-2 rounded text-sm">Download All</button>
            <button onClick={handleSendToFinance} className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm">Send to Finance</button>
          </div>
        </div>

        {/* table data */}
        <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md rounded-lg">
          <table className="min-w-full table-auto md:table-fixed text-sm">
            <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
              <tr>
                <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Title</th>
                <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                  <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                    <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                    {/* <p className="text-sm text-center text-gray-500">Loading reports...</p> */}
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr className="dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white">
                  <td colSpan="6" className="py-4 px-4 text-center text-gray-500">No reports found</td>
                </tr>
              ) : (
                filtered.map((r) => (
                  <tr key={r.id} className="dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white">
                    <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{r.title}</td>
                    <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{r.date}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </PayrollLayout>
  );
}
